import { State, ICondition, ILink, IStatesConfigSchema, IStateConfig } from "./State";
import { Map } from "es6-shim";
import App from "../App";
import ConsoleUtil from "../utils/ConsoleUtil";
import GameModel from "../model/GameModel";

/**
 * Parses state config and creates the state chain that controls the game.
 */
export class StateMachine {

    currentState: State;
    states: Map<string, State>;
    conditions: Map<string, ICondition>;

    public registerState(stateId: string, state: State) {
        if (!this.states) {
            this.states = new Map<string, State>();
        }
        this.states.set(stateId, state);
    }

    public get state():string {
        return this.currentState.name;
    }

    public registerCondition(conditionId: string, Condition: ICondition) {
        if (!this.conditions) {
            this.conditions = new Map<string, ICondition>();
        }
        this.conditions.set(conditionId, Condition);
    }

    public startStateMachine(statesConfig: IStatesConfigSchema) {
            this.currentState = this.states.get(statesConfig.entryPoint);
            this.parseStatesConfig(statesConfig);
            this.currentState.enter();

            //throw new Error(("Error in Sates Config"));

    }

    protected parseStatesConfig(statesConfig: IStatesConfigSchema) {
        for (let i = 0; i < statesConfig.states.length; i++) {
            this.parseState(statesConfig.states[i]);
        }
    }

    protected parseState(stateConfig: IStateConfig) {
        const state = this.getState(stateConfig.name);
        state.name = stateConfig.name;
        for (let i = 0; i < stateConfig.links.length; i++) {
            state.addLink({
                condition: this.getCondition(stateConfig.links[i].condition),
                next: this.getState(stateConfig.links[i].nextState)
            })
        }
    }

    getCondition(conditionId: string): ICondition {
        try {
            this.conditions.get(conditionId);
        } catch (e) {
            throw new Error(("Missing condition:" + conditionId));
        }

        return  this.conditions.get(conditionId);
    }

    getState(stateId: string): State {
        try {
            this.states.get(stateId);
        } catch (e) {
            throw new Error(("Missing State:" + stateId));
        }

        return  this.states.get(stateId);
    }

    public skip() {
        if (!GameModel.gameConfig.debugLogging || GameModel.gameConfig.debugLogging.states === true) {
            ConsoleUtil.warn("[STATE]: skiping started");
        }
        if (App.config.bulkSkip) {
            this.currentState.chainSkip();
        }  else if (this.readyForNextState()) {
            this.currentState.skip();
        }

    }

    protected readyForNextState() {
        return this.currentState.canExit();
    }

}

export default new StateMachine();